import graphql from './graphql';

const query = /* GraphQL */ `
  query UserLesson_listByLessonId($lessonId: ID!) {
    UserLesson_listByLessonId(lessonId: $lessonId) {
      id
      isDraft
      attended
    }
  }
`;

const UserLessonListByLessonId = async ({ lessonId }) =>
  graphql(query, {
    lessonId,
  }).then(
    // eslint-disable-next-line camelcase
    ({ UserLesson_listByLessonId }) => UserLesson_listByLessonId
  );

export default UserLessonListByLessonId;
